<fgb-page-header
  [pageTitle]="'games.page.pick.player.title'"
  [backButtonLink]="'/games/pickaplayer'"
  [showBalance]="false"
></fgb-page-header>
<fgb-fantasy-player-select [gameId]="id"></fgb-fantasy-player-select>
